"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "AnchorLink", {
  enumerable: true,
  get: function () {
    return _anchorLink.default;
  }
});
_Object$defineProperty(exports, "Button", {
  enumerable: true,
  get: function () {
    return _button.default;
  }
});
_Object$defineProperty(exports, "IconButton", {
  enumerable: true,
  get: function () {
    return _iconButton.default;
  }
});
exports.default = exports.SnackbarContent = void 0;
var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@mui/material/SnackbarContent"));
var _uiTheme = require("@kyruus/ui-theme");
var _iconButton = _interopRequireDefault(require("./icon-button"));
var _button = _interopRequireDefault(require("./button"));
var _anchorLink = _interopRequireDefault(require("./anchor-link"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsx jsx */
// above is used for `@emotion `
/*eslint-disable react/prop-types */
/*eslint-disable-line */

const defaultProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right'
  }
};
const SnackbarComponent = (0, _uiTheme.withMuiThemeAdapter)(_Snackbar.default);
const StyledSnackbarContent = /*#__PURE__*/(0, _base.default)(_SnackbarContent.default, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => {
    var _context;
    return (0, _every.default)(_context = ['mode', 'themed', 'handleIconButton']).call(_context, p => p !== prop);
  },
  target: "ejdlyzd0"
} : {
  shouldForwardProp: prop => {
    var _context2;
    return (0, _every.default)(_context2 = ['mode', 'themed', 'handleIconButton']).call(_context2, p => p !== prop);
  },
  target: "ejdlyzd0",
  label: "StyledSnackbarContent"
})(_ref => {
  let {
    mode,
    themed,
    handleIconButton
  } = _ref;
  return mode === 'error' ? `
          background-color: ${themed('color_danger')} !important;
          font-size: ${themed('font_size')};
          ${handleIconButton ? 'align-items: flex-start !important;' : ''}
          @media (min-width: 768px) {
            border-radius: ${themed('border_radius')} !important;
          }

          // Add enough padding above and below the message that if
          // it takes up a single line, it's centered relative to the
          // icon.
          ${handleIconButton ? `
            .MuiSnackbarContent-message {
              padding: calc((48px - ${themed('font_line_height')}em) / 2) 0 !important;
            }
          ` : ''}
        ` : `
          background-color: ${themed('color_text')} !important;
          font-size: ${themed('font_size')};
          ${handleIconButton ? 'align-items: flex-start !important;' : ''}
          @media (min-width: 768px) {
            border-radius: ${themed('border_radius')} !important;
          }

          // Add enough padding above and below the message that if
          // it takes up a single line, it's centered relative to the
          // icon.
          ${handleIconButton ? `
            .MuiSnackbarContent-message {
              padding: calc((48px - ${themed('font_line_height')}em) / 2) 0 !important;
            }
          ` : ''}
        `;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const SnackbarContent = exports.SnackbarContent = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    action,
    message,
    ...props
  } = _ref2;
  let themed = key => (0, _uiTheme.fromTheme)(key)(props);
  // We want to change MaterialUI's default behavior here
  const handleIconButton = action.type === _iconButton.default;
  return (0, _react2.jsx)(StyledSnackbarContent, {
    action: action,
    message: message,
    mode: props.mode,
    themed: themed,
    handleIconButton: handleIconButton,
    ref: ref
  });
});
const Snackbar = _ref3 => {
  let {
    action,
    message,
    ...props
  } = _ref3;
  return (0, _react2.jsx)(SnackbarComponent, (0, _extends2.default)({}, defaultProps, props), (0, _react2.jsx)(SnackbarContent, (0, _extends2.default)({
    action: action,
    message: message
  }, props)));
};
Snackbar.displayName = 'Snackbar';
// PropTypes taken from material-ui.

Snackbar.defaultProps = defaultProps;
var _default = exports.default = Snackbar;
SnackbarContent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SnackbarContent"
};
Snackbar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Snackbar",
  "props": {
    "anchorOrigin": {
      "defaultValue": {
        "value": "{\n  vertical: 'top',\n  horizontal: 'right'\n}",
        "computed": false
      },
      "required": false
    }
  }
};